class CategoriesHover {
    // 1. describe and create/initiate our object
    constructor() {
        this.imageWrapper = document.querySelector('.categories-hover__wrapper');
        this.categoryList = document.querySelectorAll('.categories-hover__category');
        if (this.imageWrapper && this.categoryList) {
            this.events();
        }
    }

    // 2. events
    events() {
        if(this.categoryList[0]) {
            this.handleInitialBackground(this.categoryList[0], this.imageWrapper);

        }

        this.categoryList.forEach(element => {
            element.addEventListener('mouseover', () => {
                this.handleMouseOver(element, this.imageWrapper);
            })
        });
    }

    // 3. methods (function, action...)
    handleInitialBackground(element, wrapper) {
        if (window.innerWidth < 768) {
            var bgImg = element.dataset.backgroundImageMobile;
        } else {
            var bgImg = element.dataset.backgroundImage;
        }
        wrapper.style.backgroundImage = 'url(' + bgImg + ')';
    }
    
    handleMouseOver(element, wrapper) {
        let background;
        if (window.innerWidth < 768) {
            background = element.dataset.backgroundImageMobile;
            wrapper.style.backgroundImage = 'url(' + background + ')';
        } else {
            background = element.dataset.backgroundImage;
            wrapper.style.backgroundImage = 'url(' + background + ')';
        }
    }
    
}

export default CategoriesHover;
